import type { GridProps } from '@chakra-ui/react'
import { Grid } from '@chakra-ui/react'

export interface StepNumberProps extends GridProps {
  children?: React.ReactNode
  isCurrent?: boolean
  isPassed?: boolean
}

export const StepNumber = ({
  children,
  isCurrent,
  isPassed,
  sx,
}: StepNumberProps) => {
  let borderColor = 'step-number-border'
  let bg = 'transparent'
  let color = 'step-number-color'

  if (isCurrent) {
    borderColor = 'white'
    bg = 'white'
    color = 'step-current-bg'
  } else if (isPassed) {
    borderColor = 'step-number-border'
    bg = 'step-number-passed-bg'
    color = 'step-number-passed-color'
  }

  return (
    <Grid
      sx={{
        w: 8,
        h: 8,
        placeContent: 'center',
        placeItems: 'center',
        border: '1px solid',
        borderColor,
        borderRadius: 'full',
        bg,
        color,
        ...sx,
      }}
    >
      {children}
    </Grid>
  )
}
